import {apiService} from '../index'

export class CityService {
  static async getCities () {
    return await apiService.baseApiRequest('get', '/city/', {})
  }
}
